import type {
    MisionPlansFilter, MissionPlansResponse, MissionPlanResponse,
    MissionDetailsResponse, MissionTrackPayload, MissionTrackResponse
} from "../types"
import { instance } from "./api"
import { useAuthStore } from '../stores/t-auth';

import type { MissionPilotResponse } from "../types";

// Función para obtener misiones por piloto
export async function getMissionByPilot(pilot: string) {
    const auth = useAuthStore();
    return await instance.get<MissionPilotResponse>(`/missions/pilot/${pilot}`, {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + auth.token
        }
    });
}
async function getMissionPlans(filters: MisionPlansFilter) {
    const auth = useAuthStore();
    let filtros = '?';
    const params = [
        filters.start_date ? `start_date=${filters.start_date}` : '',
        filters.end_date ? `end_date=${filters.end_date}` + '235959' : '',
        filters.source_unit ? `tipo=${filters.source_unit}` : '',
        filters.dest_unit ? `lat_zona=${filters.dest_unit}` : '',
        filters.received ? `lon_zona=${filters.received}` : '',
        filters.mission ? `mission=${filters.mission}` : ''
    ].filter(param => param).join('&');

    filtros += params;

    return await instance.get<MissionPlansResponse>("/mission/plans" + filtros, {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + auth.token
        }
    });
}

async function getMissionPlan(id: string) {
    const auth = useAuthStore();

    return await instance.get<MissionPlanResponse>(`/mission/plan/${id}`, {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + auth.token
        }
    });
}
async function listMissionPlans(filters: MisionPlansFilter) {
    const auth = useAuthStore();
    let filtros = '?';
    const params = [
        filters.start_date ? `start_date=${filters.start_date}` : '',
        filters.end_date ? `end_date=${filters.end_date}` + '235959' : '',
        filters.source_unit ? `tipo=${filters.source_unit}` : '',
        filters.dest_unit ? `lat_zona=${filters.dest_unit}` : '',
        filters.received ? `lon_zona=${filters.received}` : '',
        filters.mission ? `mission=${filters.mission}` : ''
    ].filter(param => param).join('&');

    filtros += params;

    return await instance.get<MissionPlansResponse>('/mission/plans' + filtros, {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + auth.token
        }
    });
}
async function getMissionDetails(id: number) {
    const auth = useAuthStore();

    return await instance.get<MissionDetailsResponse>(`/missions/${id}`, {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + auth.token
        }
    });
}

async function getMissionTrack(payload: MissionTrackPayload) {
    const auth = useAuthStore();
    const params = [
        payload.mission ? `mission=${encodeURIComponent(payload.mission)}` : '',
        payload.unit_id ? `unit_id=${encodeURIComponent(payload.unit_id)}` : '',
        payload.distance_threshold ? `distance_threshold=${encodeURIComponent(payload.distance_threshold)}` : ''
    ].filter(param => param).join('&');
    const query = params ? `?${params}` : '';
    return await instance.get<MissionTrackResponse>(`/units/track${query}`, {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + auth.token
        }
    });
}
export default{
    getMissionPlans,
    listMissionPlans,
    getMissionPlan,
    getMissionDetails,
    getMissionTrack,
    getMissionByPilot
};